const state = {
  configDomains: []
}

const mutations = {
  SET_CONFIG_DOMAINS(state, val) {
    state.configDomains = val
  },
  RESET_STATE(state) {
    state.configDomains = []
  }
}

export default {
  namespaced: true,
  state,
  mutations
}
